<template>
    <v-container>
        <v-row>
            <v-col cols="12" sm="12" md="12" class="px-0 pb-0">
                <p class="font-size-md description-text">{{ $t('dashboard.shortcutsIntro') }}</p>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="6" md="12" class="py-0" style="height: 25vh">
                <v-radio-group row @change="onChangePickedLayout()" v-model="localPickedLayout">
                    <v-layout row wrap align-center>
                        <v-flex column md3 class="px-2">
                            <v-radio ref="layout_1" value="1" class="mx-auto mb-2" style="display: table" data-cy="radiobutton-layout-1"></v-radio>

                            <p style="cursor: pointer" @click="onChangeAppLayoutSelector(1)" data-cy="layout-selector-1">
                                <template>
                                    <app-layout-selector
                                        v-bind:selectorOptions="{
                                            numberOfRows: 3,
                                            cardsInFirstRow: 1,
                                            cardsInSecondRow: 1,
                                            cardsInThirdRow: 1,
                                        }"
                                    >
                                    </app-layout-selector>
                                </template>
                            </p>
                        </v-flex>

                        <v-flex column md3 class="px-2">
                            <v-radio ref="layout_2" value="2" class="mx-auto mb-2" style="display: table" data-cy="radiobutton-layout-2"> </v-radio>

                            <p style="cursor: pointer" @click="onChangeAppLayoutSelector(2)" data-cy="layout-selector-2">
                                <template>
                                    <app-layout-selector
                                        v-bind:selectorOptions="{
                                            numberOfRows: 3,
                                            cardsInFirstRow: 1,
                                            cardsInSecondRow: 1,
                                            cardsInThirdRow: 2,
                                        }"
                                    >
                                    </app-layout-selector>
                                </template>
                            </p>
                        </v-flex>

                        <v-flex column md3 class="px-2">
                            <v-radio ref="layout_3" value="3" class="mx-auto mb-2" style="display: table" data-cy="radiobutton-layout-3"> </v-radio>

                            <p style="cursor: pointer" @click="onChangeAppLayoutSelector(3)" data-cy="layout-selector-3">
                                <template>
                                    <app-layout-selector
                                        v-bind:selectorOptions="{
                                            numberOfRows: 3,
                                            cardsInFirstRow: 1,
                                            cardsInSecondRow: 2,
                                            cardsInThirdRow: 2,
                                        }"
                                    >
                                    </app-layout-selector>
                                </template>
                            </p>
                        </v-flex>

                        <v-flex column md3 class="px-2">
                            <v-radio ref="layout_4" value="4" class="mx-auto mb-2" style="display: table" data-cy="radiobutton-layout-4"></v-radio>

                            <p style="cursor: pointer" @click="onChangeAppLayoutSelector(4)" data-cy="layout-selector-4">
                                <template>
                                    <app-layout-selector
                                        v-bind:selectorOptions="{
                                            numberOfRows: 3,
                                            cardsInFirstRow: 2,
                                            cardsInSecondRow: 2,
                                            cardsInThirdRow: 2,
                                        }"
                                    >
                                    </app-layout-selector>
                                </template>
                            </p>
                        </v-flex>
                    </v-layout>
                </v-radio-group>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12" sm="12" md="12" class="py-0">
                <p class="font-size-md description-text" style="min-height: 70px" data-cy="number-of-cards-info">
                    {{ $t('dashboard.shortcutsLayoutHint') }}
                    <span v-if="numberOfCards">
                        {{ $t('dashboard.shortcutsQuantity') }} <b class="font-size-md description-text dark-blue-color">{{ selectedCustomShortcuts.length }}</b> {{ $t('dashboard.of') }} <b class="font-size-md description-text dark-blue-color">{{ numberOfCards }}</b>
                    </span>
                </p>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <div style="height: 23vh !important; max-height: 23vh !important; overflow-y: scroll">
                    <v-treeview
                        item-key="id"
                        selectable
                        selection-type="independent"
                        selected-color="#154579"
                        hoverable
                        open-all
                        :class="blockSelection ? 'custom-block-unchecked' : ''"
                        v-model="selectedCustomShortcutsLocal"
                        :items="config_custom_shortcuts"
                        @input="onChangeCustomShortcutsCheckboxes"
                        data-cy="custom-shortcuts-checkboxes-treeview"
                    >
                        <template v-slot:label="{ item }">{{ tb(item.name) }}</template>
                        <template v-slot:prepend="{ open }">
                            <v-icon class="appbar-icon-button btn-bg-color-blue dark-blue-color">
                                {{ open ? 'mdi-folder-open-outline' : 'mdi-folder-outline' }}
                            </v-icon>
                        </template>
                    </v-treeview>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import AppLayoutSelector from './../Components/AppLayoutSelector';

export default {
    components: { AppLayoutSelector },

    props: ['user_custom_shortcuts_layout', 'config_custom_shortcuts', 'pickedLayout', 'selectedCustomShortcuts'],

    data: () => ({
        numberOfCards: null,
        localPickedLayout: null,
    }),

    model: {
        prop: 'selectedCustomShortcuts',
        event: 'selected-custom-shortcuts-change',
    },

    computed: {
        selectedCustomShortcutsLocal: {
            get: function () {
                return this.selectedCustomShortcuts;
            },
            set: function (value) {
                this.$emit('selected-custom-shortcuts-change', value);
            },
        },

        blockSelection() {
            if (!this.numberOfCards) return false;
            return this.selectedCustomShortcuts.length >= this.numberOfCards;
        },
    },

    mounted() {
        this.onChangeAppLayoutSelector(this.pickedLayout);
    },

    methods: {
        onChangeAppLayoutSelector(payload) {
            this.localPickedLayout = payload.toString();
            this.onChangePickedLayout(payload);
        },

        onChangePickedLayout(payload) {
            if (payload === undefined) {
                payload = parseInt(this.localPickedLayout);
            }

            if (payload == 1) {
                this.numberOfCards = 3;
            } else if (payload == 2) {
                this.numberOfCards = 4;
            } else if (payload == 3) {
                this.numberOfCards = 5;
            } else if (payload == 4) {
                this.numberOfCards = 6;
            }

            window.EventBus.$emit('on-change-picked-layout', payload, this.numberOfCards);
        },

        onChangeCustomShortcutsCheckboxes(items) {
            window.EventBus.$emit('on-change-custom-shortcuts-checkboxes', items);
        },
    },
};
</script>

<style>
button.v-treeview-node__toggle + button.v-treeview-node__checkbox {
    display: none !important;
}

.treeCheckBox {
    margin-top: 0px;
    margin-left: 5px;
    margin-right: 5px;
    max-height: 30px;
}

/* Disabling all unchecked checkboxes if the number of selected shortcuts is the same as the layout available cards */
.custom-block-unchecked > .v-treeview-node > .v-treeview-node__children > .v-treeview-node--leaf > .v-treeview-node__root > .mdi-checkbox-blank-outline {
    pointer-events: none;
}
</style>
